import { PriceableItemOrigin } from "elephant-web/gql";
import mapValues from "lodash.mapvalues";
import { useIntl } from "react-intl";
import { type InferType, lazy, mixed, number, object, string } from "yup";

export const useFormSchema = () => {
  const { formatMessage } = useIntl();

  const priceSchema = object({
    price: number()
      .required(
        formatMessage({
          id: "priceList.addItems.price.required",
          defaultMessage: "Please enter a price",
        }),
      )
      .typeError(
        formatMessage({
          id: "priceList.addItems.price.typeError",
          defaultMessage: "Please enter a valid number",
        }),
      )
      .test(
        "greater than 0",
        formatMessage({
          id: "priceList.addItems.price.positive",
          defaultMessage: "Please enter a positive number",
        }),
        (v) => (v ?? 0) >= 0,
      ),
    revenueDepartmentId: string().required(
      formatMessage({
        id: "priceList.addItems.revenueDepartment.required",
        defaultMessage: "Please enter the revenue department",
      }),
    ),
    tariffId: string().required(),
    name: string().required(),
    externalReference: object({
      foreignId: string().required(),
      origin: mixed<PriceableItemOrigin>()
        .required()
        .test((v) =>
          Object.values(PriceableItemOrigin).includes(v as PriceableItemOrigin),
        ),
    }),
  }).nullable();

  return lazy((obj) => object(mapValues(obj, () => priceSchema)));
};

export type AddItemsFormData = InferType<ReturnType<typeof useFormSchema>>;
